/* eslint-disable react/no-unescaped-entities */
import React, { useEffect, useState } from 'react'
import { Navigate, useParams } from 'react-router-dom'
import { venueService } from '../../../services/venue.service'
import { CardEvent } from '../../../components/Events/CardEvent'
import './style.scss'

export const VenueDetail = () => {
  const { idVenue } = useParams()
  const [venue, setVenue] = useState({})
  useEffect(() => {
    const getVenues = async () => {
      try {
        const dbVenue = await venueService.getOneVenue(idVenue)
        setVenue(dbVenue)
        // console.log(dbVenue)
      } catch (error) {
        console.log(error.response.status)
        setVenue(null)
      }
    }
    getVenues()
  }, [])

  if (venue === null) {
    return <Navigate to="/recurso-no-encontrado" />
  }
  console.log(venue.nextEvents)
  console.log(venue.web)
  console.log(venue.facebook)
  console.log(venue.twitter)
  console.log(venue.instagram)

  return (
    <>
      <div className="">
        <section className="container mt-2 mt-lg-4 mt-xl-5">
          <div className="row">
            {/* Content */}
            <div className='venue-header' id='parent'>
              <div className="card_descripcion text-front">
              <h4 className="h1 pb-md-2 pb-lg-3">
              <span>Recinto</span>
              </h4>
              <h2>
              <span>{venue.nombre}</span>
              </h2>
              </div>
              <div className='img-wrapper2 img-edit'>
                <img className='crop' src = {venue.foto_portada}></img>
              </div>
            </div>
            <div className="col-xl-7 col-lg-8 col-md-7 order-md-1 mb-5">
              <div className="card_descripcion">
              <div className = "row">
              <div className='col'>
                <h3 id="ubicacion" className="mb-4">Sobre el recinto</h3>
              </div>
              <div className='col col-lg-2'>
                <button className="btn-primary shadow-none rounded-3 buttoni" type="button" data-bs-toggle="collapse" data-bs-target="#descripcion_recinto" aria-expanded="false" aria-controls="descripcion_recinto">
                <h4>-</h4>
                </button>
              </div>
              </div>
              <div id='descripcion_recinto' className='collapse'>
                <p className="pb-4 mb-3">
                    {venue.descripcion}.
                </p>
              </div>
              <ul className="list-unstyled">
                <li className="d-flex align-items-center mb-2 flex-wrap">
                  <b>Dirección: {venue.direccion}, {venue.ciudad}, {venue.estado}.</b>
                </li>
                <li className="d-flex align-items-center mb-2">
                  <b>Capacidad: {venue.capacidad} personas</b>
                </li>
              </ul>
              </div>
            </div>
          {/* Sidebar (Course summary) */}
            <aside className="col-lg-4 col-md-5 offset-xl-1 order-md-1 mb-5">
              <div className="card_descripcion">
                <h4 className="h4 pb-md-2 pb-lg-3 ">Enlace a RRSS</h4>
                  <ul className="list-unstyled mb-5">
                  { /* Aquí se checa si el recinto tiene página web */ }
                  {
                  venue.web !== '#'
                    ? <li className="d-flex align-items-center mb-2">
                      <a href= {venue.web} rel="noreferrer" target='_blank' className='linkini'> Página web</a>
                    </li>
                    : null
                  }
                  { /* Aquí se checa si el recinto tiene facebook */ }
                  {
                  venue.facebook !== '#'
                    ? <li className=" align-items-center mb-2">
                      <a href= {venue.facebook} rel="noreferrer" target='_blank' className='linkini'> Facebook</a>
                    </li>
                    : null
                  }
                  { /* Aquí se checa si el recinto tiene twitter */ }
                  {
                  venue.twitter !== '#'
                    ? <li className="d-flex align-items-center mb-2">
                    <a href= {venue.twitter} rel="noreferrer" target='_blank' className='linkini'>Twitter</a>
                    </li>
                    : null
                  }
                  { /* Aquí se checa si el recinto tiene instagram */ }
                  {
                  venue.instagram !== '#'
                    ? <li className="d-flex align-items-center">
                    <a href= {venue.instagram} rel="noreferrer" target='_blank' className='linkini'> Instagram</a>
                    </li>
                    : null
                  }
                  </ul>
              </div>
            </aside>
          </div>
          <section>
              <h3 className="pb-4 mb-2 mb-md-0">
                Próximos eventos
              </h3>
            <div className="row d-flex flex-row flex-nowrap overflow-auto">
              {
              venue.nextEvents !== undefined
                ? venue.nextEvents.slice(0, 12).map((nextevent, index) => (

                <div className="col-12 col-md-3"
                  key={index}
                >
                  <CardEvent
                    // setIsRejected={setIsRejected}
                    // isRejected={isRejected}
                    // isAdmin={isAdmin}
                    {...nextevent}
                  />
                </div>
                ))
                : ''
              }
            </div>
            </section>
        </section>
      </div>
    </>
  )
}
